class ClickTracker {

	static name() {
		return 'ClickTracker';
	}

	constructor(props, el) {
		this.el = document;
		this.socialDomains = [
			'facebook.com',
			'twitter.com',
			'linkedin.com',
			'instagram.com',
			'youtube.com'
		];

		this.handleClick = this.handleClick.bind(this);
	}

	init() {
		this.el.addEventListener('click', this.handleClick);
		console.log('ClickTracker initialized');
	}

	handleClick(event) {
		
		var dataLayer;
		dataLayer = window.dataLayer || [];
		
		const target = event.target.closest('a, button');
		if (!target) return;

		const linkText = target.textContent.trim();
		const linkUrl = target.href || target.getAttribute('href') || '';
		const isAnchor = target.tagName.toLowerCase() === 'a';
		const isButton = target.tagName.toLowerCase() === 'button';
		const isCTA = target.classList.contains('btn');
		const normalizedText = linkText.toLowerCase();

		let isInternal = false;
		try {
			const resolvedUrl = new URL(linkUrl, location.href);
			isInternal = isAnchor && (resolvedUrl.hostname === location.hostname);
		} catch (e) {
			// skip invalid URLs
		}

		// Internal Link
		if (isInternal) {
			dataLayer.push({
				event: 'internal_click',
				link_text: linkText,
				link_url: linkUrl
			});
		}

		// Social Media Exit
		if (isAnchor && !isInternal && this.socialDomains.some(domain => linkUrl.includes(domain))) {
			dataLayer.push({
				event: 'social_exit',
				link_text: linkText,
				link_url: linkUrl
			});
		}

		// CTA Click
		if (isCTA) {
			dataLayer.push({
				event: 'cta_click',
				link_text: linkText,
				link_url: linkUrl
			});
		} 

		// Learn More
		if (normalizedText === 'learn more') {
			dataLayer.push({
				event: 'learn_more',
				link_text: linkText,
				link_url: linkUrl
			});
		}

		// View Categories
		if (normalizedText === 'view categories') {
			dataLayer.push({
				event: 'view_categories'
			});
		}

		// View Products
		if (normalizedText === 'view products') {
			dataLayer.push({
				event: 'view_products'
			});
		}
		
		// Open click inside calculator
		if (
			isAnchor &&
			normalizedText === 'open' &&
			target.closest('.js-calculator-container')
		) {
			this.pushEvent({
				event: 'calculator_open',
				link_text: linkText,
				link_url: linkUrl
			});
		}
	}
}

export default ClickTracker;
